import axios from "axios";

export const baseURL = process.env.REACT_APP_API_ENDPOINT;
export const imgURL = process.env.REACT_APP_IMAGES_ENDPOINT;
export default axios.create({
  baseURL,
  headers: { "Access-Control-Allow-Origin": "*" },
});

export const axiosPrivate = axios.create({ baseURL });
